import request from '@/utils/request';

export function getInvoiceEntityConfigs() {
  return request({ url: '/admin/invoice_entity_config', method: 'get' });
}

export function saveInvoiceEntityConfig(data) {
  return request({
    url: '/admin/invoice_entity_config' + (data.id ? '/' + data.id : ''),
    method: data.id ? 'put' : 'post',
    data,
  });
}

export function updateInvoiceEntityStatus(id, autoInvoiceEnabled) {
  return request({
    url: '/admin/invoice_entity_config/' + id + '/status',
    method: 'put',
    data: { auto_invoice_enabled: autoInvoiceEnabled },
  });
}

export function getInvoiceSystemConfig() {
  return request({ url: '/admin/invoice_system_config', method: 'get' });
}

export function saveInvoiceSystemConfig(data) {
  return request({ url: '/admin/invoice_system_config', method: 'put', data });
}
